import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=7e1003f5&"
import script from "./BoxItem.vue?vue&type=script&lang=js&"
export * from "./BoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports